var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.70699 21.1212C8.31646 21.5117 7.68345 21.5117 7.29292 21.1212C6.9024 20.7306 6.9024 20.0976 7.29292 19.7071L16 11.0001L24.707 19.7071C25.0975 20.0976 25.0975 20.7306 24.707 21.1212C24.3165 21.5117 23.6834 21.5117 23.2929 21.1212L16 13.8282L8.70699 21.1212Z",
    fill: "#3F3F3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/Arrow-up.20bddfe45c70c79a8cd40fdf10e29744.svg";
export { ForwardRef as ReactComponent };